import { datadogRum } from '@datadog/browser-rum'
import React from 'react';
import ReactDOM from 'react-dom';
import 'es6-symbol/implement';
import 'es6-promise/auto';
// Styles
import '@availity/block-ui/dist/index.css';
import '@availity/date/styles.scss';
import 'availity-uikit/scss/_bootstrap.scss';
import './index.scss';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './Common/interceptor/interceptor-api';
import App from './App';


require('isomorphic-fetch');
datadogRum.init({
  applicationId: '3c05aaec-7e93-42f7-b31a-6c6278314386',
  clientToken: 'pube274e32d336969bf4817914aa26d6e1e',
  site: 'datadoghq.com',
  service: 'tap-reimbursementrequestform-ui',
  //  env: 'production',
  version: '1.0.0',
  sampleRate: 100,
  sessionReplaySampleRate: 100, // if not included, the default is 100
  trackResources: true,
  trackLongTasks: true,
  trackInteractions: true,
  defaultPrivacyLevel: 'mask',
  allowedTracingOrigins: ["https://perf.aws-providerexperience.anthem.com/tapreimbursementrequestform/wa/","/https:\/\/.*\.perf.aws-providerexperience.anthem.com/tapreimbursementrequestform/wa/\.com/"]

})
ReactDOM.render(<App />, document.getElementById('root'));
